import { render, staticRenderFns } from "./YouTubeVoice.vue?vue&type=template&id=2e2fdd24&scoped=true&"
import script from "./YouTubeVoice.vue?vue&type=script&lang=js&"
export * from "./YouTubeVoice.vue?vue&type=script&lang=js&"
import style0 from "./YouTubeVoice.vue?vue&type=style&index=0&id=2e2fdd24&prod&lang=css&"
import style1 from "./YouTubeVoice.vue?vue&type=style&index=1&id=2e2fdd24&prod&scoped=true&lang=css&"
import style2 from "./YouTubeVoice.vue?vue&type=style&index=2&id=2e2fdd24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2fdd24",
  null
  
)

export default component.exports